import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

const messages: {
  [key: string]: MessageDescriptor;
} = defineMessages({
  processingFilesTitle: {
    id: 'boxFileRequest.upload.processing.title',
    description: 'Title for precessing files',
    defaultMessage: 'Processing your files',
  },
  processingFilesMessage: {
    id: 'boxFileRequest.upload.processing.message',
    description: 'Message for files during processing',
    defaultMessage: 'Keep window open until you see a success message',
  },
  loadingIndicatorAriaLabel: {
    id: 'boxFileRequest.upload.loadingIndicatorAriaLabel',
    description:
      'Aria label of the loading indicator which indicates processing the upload',
    defaultMessage: 'Processing icon',
  },
});

export default messages;
